import { cn } from "~/utils";
import { Text } from "~/components/text";

interface KeyValueRowProps {
  label: string;
  value: React.ReactNode;
  className?: string;
}

export const KeyValueRow = ({ label, value, className }: KeyValueRowProps) => {
  if (value === null || value === undefined || value === "") return null;

  return (
    <div className={cn("flex gap-4 py-1.5 text-sm", className)}>
      <Text as="span" variant="detail" className="w-56 shrink-0">
        {label}
      </Text>
      <Text as="span" variant="body" className="wrap-break-word min-w-0">
        {value}
      </Text>
    </div>
  );
};
